export enum MigrationStatus {
  USER_ACTION,
  IN_PROGRESS,
  SUCCESS,
  ERROR,
}
